export enum SearchInputFileType {
    PDF = 'application/pdf',
    XLSX = '',
}

export enum SearchInputFileTypeName {
    PDF = 'PDF',
    XLSX = 'XLSX',
}

export enum SearchInputFileTypeIconPath {
    PDF = 'pdf-file-icon.svg',
    XLSX = 'excel-icon.svg',
    DOCX = 'docx.svg',
}

export enum UploadState {
    Idle,
    Uploading,
    Processing,
    Done,
}
